import sanitizeHtml from 'sanitize-html'

const options = {
    default: {
        allowedTags: ['div', 'p', 'a', 'span', 'ol', 'ul', 'li', 'strong', 'b', 'i', 'u', 'br'],
        allowedSchemes: ['http', 'https', 'mailto', 'tel'],
        allowedSchemesAppliedToAttributes: ['href'],
        allowedSchemesByTag: {
            a: ['http', 'https', 'mailto', 'tel'],
        },
        allowedAttributes: {
            '*': ['style'],
            a: ['href', 'style']
        },
        allowedStyles: {
            '*': {
                'color': [/.*/],
                'background-color': [/.*/],
                'text-align': [/^left$/, /^right$/, /^center$/],
                'direction': [/^ltr$/, /^rtl$/],
            },
        },
        disallowedTagsMode: 'completelyDiscard',
        nonBooleanAttributes: ['*'],
    },
    full: {
        allowedTags: ['img', 'p', 'span', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'div', 'hr', 'li', 'main', 'ol', 'pre', 'ul', 'a', 'abbr', 'b', 'bdi', 'br', 'code', 'data', 'i', 'kbd', 'mark', 'q', 'small', 'strong', 'sub', 'sup', 'caption', 'col', 'colgroup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'em', 's', 'u'],
        allowedSchemes: ['http', 'https', 'mailto', 'tel'],
        allowedSchemesAppliedToAttributes: ['href', 'src'],
        allowedSchemesByTag: {
            a: ['http', 'https', 'mailto', 'tel'],
            img: ['http', 'https']
        },
        allowedAttributes: {
            '*': ['style'],
            a: ['href', 'style'],
            img: ['src', 'style']
        },
        // allowedClasses: {},
        allowedStyles: {
            '*': {
                'color': ['*'],
                'background-color': ['*'],
                'text-align': [/^left$/, /^right$/, /^center$/],
                'direction': [/^ltr$/, /^rtl$/],
            },
        },
        disallowedTagsMode: 'completelyDiscard',
        nonBooleanAttributes: ['*'],
    }
};

export default {
    install(app) {
        app.directive('sanitize', (el, binding) => {
            if (binding.value === binding.oldValue)
                return;
            let args = options[Object.keys(binding.modifiers)[0] ?? 'default'];
            if (!/(<([^>]+)>)/.test(binding.value))
                el.innerText = binding.value;
            else
                el.innerHTML = sanitizeHtml(`<div>${binding.value}</div>`, args);
        })
    },
};
